// 세션 룰(rnd 응답, 빈도순 정렬됨) → 뇌 워드클라우드용 { word, weight } 배열.
// keywords를 순서 유지 dedup, 앞(상위)일수록 큰 weight. 서버가 rules를 빈도순으로 내려주므로
// 순서 = 빈도 순위. BroadcastBox 피크·OnAirPage dev 브레인이 공유.
export function rulesToWeightedWords(rules) {
  const ordered = [];
  const seen = new Set();
  for (const r of rules || []) {
    for (const k of r.keywords || []) {
      if (!seen.has(k)) {
        seen.add(k);
        ordered.push(k);
      }
    }
  }
  return ordered.map((word, i) => ({ word, weight: ordered.length - i }));
}
